var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"telegram-btn"}},[_c('vue-telegram-login',{attrs:{"mode":"redirect","requestAccess":"write","telegram-login":"leakcheckcc_bot","redirectUrl":"https://api.checkleaked.cc/auth/telegram","radius":"2px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }